import { render, staticRenderFns } from "./tenetAdd.vue?vue&type=template&id=2aa1606a&scoped=true"
import script from "./tenetAdd.vue?vue&type=script&lang=ts"
export * from "./tenetAdd.vue?vue&type=script&lang=ts"
import style0 from "./tenetAdd.vue?vue&type=style&index=0&id=2aa1606a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1606a",
  null
  
)

export default component.exports